import Highway from '@dogstudio/highway';
import { TweenMax, Power3 } from 'gsap';

class PageTransition extends Highway.Transition {
  in(from, to, done) {
    // reset scroll
    window.scrollTo(0, 0);

    // remove old view
    if (document.querySelectorAll('[data-router-view]').length > 2) {
      document.querySelectorAll('[data-router-view]')[1].remove();
      from.remove();
    } else {
      from.remove();
    }

    TweenMax.fromTo(
      to,
      0.4,
      { opacity: 0 },
      { opacity: 1, onComplete: done }
    );
  }

  out(from, done) {
    const mapAside = document.querySelector('.js-map-aside');

    // close map (aside) if open
    if (mapAside.offsetWidth > 120) {
      TweenMax.to(
        mapAside,
        0.6,
        { width: 120, Ease: Power3.easeInOut }
      );
    }

    done();
  }
}

export default PageTransition;
